// Buy Now Quick View — copy of QuickView with checkout permalink instead of add-to-cart.
// Kept separate so the original <quick-view> / Add to Cart drawer is untouched.
(() => {
  const defineQuickViewBuyNow = () => {
    const XModal = customElements.get('x-modal');
    if (!XModal) {
      customElements.whenDefined('x-modal').then(defineQuickViewBuyNow);
      return;
    }
    if (customElements.get('quick-view-buy-now')) return;

    class QuickViewBuyNow extends XModal {
      get selector() {
        return '.quick-view__content';
      }

      beforeShow() {
        super.beforeShow();
        this.quickview();
      }

      afterShow() {
        super.afterShow();
        document.dispatchEvent(new CustomEvent('quickview-buy-now:open', {
          detail: { productUrl: this.getAttribute('data-product-url') }
        }));
      }

      afterHide() {
        super.afterHide();
        const drawerContent = this.querySelector(this.selector);
        if (drawerContent) drawerContent.innerHTML = '';
      }

      quickview() {
        const drawerContent = this.querySelector(this.selector);
        if (!drawerContent) return;

        const productUrl = this.getAttribute('data-product-url').split('?')[0];
        const sectionUrl = `${productUrl}?view=modal`;

        fetch(sectionUrl)
          .then((response) => response.text())
          .then((responseText) => {
            setTimeout(() => {
              const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
              const productElement = parsedHTML.querySelector(this.selector);
              if (!productElement) return;

              this.setInnerHTML(drawerContent, productElement.innerHTML);
              this.applyBuyNowMode(drawerContent);
              theme.a11y.trapFocus(this, this.focusElement);

              document.dispatchEvent(new CustomEvent('quickview-buy-now:loaded', {
                detail: { productUrl: this.getAttribute('data-product-url') }
              }));
            }, 200);
          })
          .catch((e) => {
            console.error(e);
          });
      }

      applyBuyNowMode(root) {
        const form = root.querySelector('form[is="product-form"]');
        const submitButton = root.querySelector('.product-form__submit:not(.product-form__submit--buy-now)');
        if (!form || !submitButton) return;

        submitButton.type = 'button';
        submitButton.removeAttribute('name');
        // Keep buy-now class so variant:change label updates stay on "Buy Now"
        submitButton.classList.add('product-form__submit--buy-now');
        // So ProductForm.submitButtons / toggleSubmitButton can disable on sold-out
        submitButton.setAttribute('data-product-form', form.getAttribute('id'));
        submitButton.setAttribute('aria-label', theme.variantStrings.buyNow);

        const label = submitButton.querySelector('.btn-text > span') || submitButton.querySelector('.btn-text');
        if (label) label.textContent = theme.variantStrings.buyNow;

        root.querySelectorAll('.shopify-payment-button, [data-shopify="payment-button"]').forEach((el) => {
          el.hidden = true;
        });

        submitButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (submitButton.hasAttribute('disabled') || submitButton.getAttribute('aria-disabled') === 'true') return;

          const formData = new FormData(form);
          const variantId = formData.get('id') || form.querySelector('[name="id"]')?.value;
          const quantity = parseInt(formData.get('quantity'), 10) || 1;
          if (!variantId) return;

          window.location.href = `${theme.routes.cart_url}/${variantId}:${quantity}`;
        });
      }

      setInnerHTML(element, innerHTML) {
        element.innerHTML = innerHTML;
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }
    }

    customElements.define('quick-view-buy-now', QuickViewBuyNow);
  };

  defineQuickViewBuyNow();
})();
